import React from 'react';
import projects from '../config/projects';

import Modal from './common/modal';
import Button from './common/button';
import credentials from '../config/credentials';

class Projects extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      projectId: 0,
    };

    this.project = {};
  }

  render() {
    if (this.state.projectId !== 0) {
      projects.find(section => {
        const prj = section.projects.find(project => project.id === this.state.projectId);
        if (prj) {
          this.project = prj;
        }
        return prj;
      });
    }
    return (
      <div className="mainContainer">
        <Modal open={this.state.projectId !== 0} onClose={() => this.setState({projectId: 0})}>
          <div id="projectDialog">
            <img
              className="projectDialogImage"
              src={this.project.image}
              alt={'img_' + this.project.title}
            />
            <div className="projectDialogContent">
              <div className="projectDialogTitle">{this.project.title}</div>
              <div className="projectDialogDescription">
                {this.project.description ?
                  this.project.description.split('\n').map((text, i) => <p key={i}>{text}</p>) :
                  ''}
              </div>
            </div>
            <Button id="close" onClick={() => this.setState({projectId: 0})}>Close</Button>
          </div>
        </Modal>

        <h1 id="helloMsg">
          <div>Hello! I'm <span className="highlight-color">Serg</span></div>
          <div id="clarification" className="text-size-small">(Well... officially Sergio)</div>
        </h1>

        <img id="me" src="/images/me.png" alt="This is me"/>

        <div id="motivation">
          “Life cannot consist in solving one miserable problem after another, there must be reasons for you to <span
          style={{color: 'white'}}>get up in the morning</span> and to be willing to live and <span
          className="highlight-color">get excited about the future</span>”
        </div>

        <div id="welcomeText">
          Check some of my projects
        </div>

        <div id="projects">
          {projects.map(prj => (
            <div className="section" key={prj.section}>
              <div className="title">{prj.section}</div>
              <div className="frame">
                {prj.projects.map(project => (
                  <div key={project.id} className="prjImageFrame">
                    <img
                      className="prjImage"
                      src={project.image}
                      alt={'img_' + project.title}
                    />
                    <div className="prjTitle">{project.title}</div>
                    <div className="prjOverlay" onClick={() => this.setState({projectId: project.id})}>
                      <div className="infoBtn">Read more</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div id="whatIsNext">
          <div className="title">What is next?</div>
          <div className="onlyYouDecide">Only you can decide it</div>
          <div className="content">
            <div>Check out my <a href={credentials.resume} target="_blank" rel="noopener noreferrer">resume</a></div>
            <div>Check out my <a href={credentials.github} target="_blank" rel="noopener noreferrer">github</a><span
              className="codeOfThis">and the code of this :)</span></div>
            <div>Check out my <a href={credentials.linkedin} target="_blank" rel="noopener noreferrer">linkedIn</a>
            </div>
          </div>
          <div className="call">Give me a call! +34 627 15 19 15</div>
        </div>
      </div>
    );
  }
}

export default Projects;
